<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-25 15:16:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 14:42:54
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goods-info flex">
		<img class="goods-left mr-8" :src="row.productPic" alt="" />
		<div class="goodos-right">
			<div class="flex goods-name flex-align-center">
				<platform-icon style="flex-shrink: 0" class="mr-4" :platformId="row.platformId"></platform-icon>
				<el-tooltip placement="top" v-ak-tooltip-auto-show>
					<div slot="content">
						<span class="pointer fz-12" @click="goGoodDetail(row)">{{ row.outerProductName | formatEmpty }}</span>
					</div>
					<span class="ml-4 line-ellipsis product-name fz-12 pointer" style="width: 142px">{{ row.outerProductName | formatEmpty }}</span>
				</el-tooltip>
				<ID-tag label="商品ID" :id="row.outerProductId" />
			</div>
			<div class="flex rate-sales flex-align-center">
				<div class="goods-info-text font-h6-regular">普通佣金率：{{ row.baseCommissionRate | formatEmpty }}%</div>
				<div class="goods-info-text font-h6-regular ml-12">销量：{{ row.totalOrder | formatEmpty | formatPrice2 }}</div>
			</div>
			<div class="flex flex-align-center">
				<div class="goods-info-text font-h6-regular">售价：¥{{ row.salePrice | formatEmpty | formatPrice2 }}</div>
				<div class="goods-info-text font-h6-regular ml-12">库存：{{ row.stockNum | formatEmpty | formatPrice2 }}</div>
			</div>
			<div class="flex">
				<rd-text class="font-h6-regular goods-info-text pointer" width="160">店铺：{{ row.outerShopName | formatEmpty }} </rd-text>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
import IDTag from '@/components/ui/IDTag';
import { copy } from '@/utils/common';
export default {
	mixins: [mixin],
	components: {
		IDTag,
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		goGoodDetail({ productUrl: link }) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
	},
};
</script>
<style lang="less" scoped>
.goods-info {
	.goods-left {
		border-radius: 4px;
		width: 60px;
		height: 60px;
	}
	.goods-name {
		line-height: 20px;
	}
	.tag-label {
		padding: 0 3px;
		position: relative;
		color: @color-regular;
		top: -1px;
		height: 17px;
		border-radius: 3px;
		background-color: @color-gy3;
		margin-left: 4px;
	}
	.product-name {
		color: @color-gy9;
		font-weight: bold;
	}
	.goods-info-text {
		color: @color-gy7 !important;
	}
	.goods-info-text {
		/deep/ .text-content {
			color: @color-gy7 !important;
		}
	}
}
</style>
